export function getReferralProgressState(progress = 0, step = 5) {
  const safeStep = step > 0 ? step : 5;
  const safeProgress = Math.max(0, Number(progress) || 0);

  const rewardsEarned = Math.floor(safeProgress / safeStep);
  const displayGoal = (rewardsEarned + 1) * safeStep;
  const tierStart = rewardsEarned * safeStep;
  const progressInTier = safeProgress - tierStart;
  const progressPercent = Math.min(( safeProgress/ displayGoal) * 100, 100);
  const remaining = Math.max(displayGoal - safeProgress, 0);

  return {
    progress: safeProgress,
    step: safeStep,
    displayGoal,
    rewardsEarned,
    progressInTier,
    progressPercent,
    remaining,
  };
}

export function formatRewardsEarnedLabel(rewardsEarned = 0) {
  if (rewardsEarned <= 0) return "No rewards earned yet";

  return rewardsEarned === 1
    ? "1 reward earned"
    : `${rewardsEarned} rewards earned`;
}

export function buildReferralLink(couponData) {
  const listingId = couponData?.listingId;
  const couponCode = couponData?.couponCode;
  if (!listingId || !couponCode) return "";

  const baseUrl = (process.env.REACT_APP_URL || window.location.origin).replace(/\/$/, "");
  return `${baseUrl}/dashboard/property/${listingId}?coupon=${couponCode}`;
}
